import PinInput from "@components/shared/PinInput";

import { CircularProgressIndicator } from "@components/shared/CircularProgressIndicator";
import Divider, { VerticalDivider } from "@components/shared/Divider";
import { Button } from "@components/ui/button";
import { useState } from "react";
import { MdArrowBack, MdLink, MdOutlineWatchLater } from "react-icons/md";
import DataFetchStatus from "types/DataFetchStatus";
import CustomCarousel from "./CustomCarousel";
import { pairInstructions, screenTypes } from "./data";
import { ScreenInfo } from "./ScreenInfoPage";

interface ScreenPairPageProps {
  onPinChange: (pin: string) => void;
  screenInfo?: ScreenInfo;
  screenCreateStatus: DataFetchStatus;
  setSelectedPage: (val: number) => void;
  isPairAgain?: boolean;
  onSubmit: () => void;
  onPairLater: () => void;
  actions?: React.ReactNode;
}

function ScreenPairPage(props: ScreenPairPageProps) {
  const [isPairNowActive, setisPairNowActive] = useState(props.isPairAgain);

  if (isPairNowActive)
    return (
      <div className="flex h-full min-h-[550px] w-full flex-col items-center justify-center gap-2">
        <div className="h-[350px] w-full py-4">
          <CustomCarousel
            items={pairInstructions[props.screenInfo?.screenType ?? "web"]}
          />
        </div>

        <div className="text-center font-bold">Enter Pairing code</div>

        <PinInput totalDigits={6} onSubmit={props.onPinChange} />

        <div className="text-center text-xs text-gray-400">
          * Please enter the pairing code on the screen
        </div>

        <div className="flex w-full flex-row items-center justify-between gap-4">
          {props.actions}
          {props.isPairAgain ? (
            <div></div>
          ) : (
            <Button
              variant="ghost"
              type="button"
              disabled={props.screenCreateStatus === "fetching"}
              onClick={() => {
                props.setSelectedPage(0);
              }}
            >
              <MdArrowBack />
              Previous
            </Button>
          )}

          <Button
            type="button"
            onClick={() => {
              props.onSubmit();
            }}
            disabled={props.screenCreateStatus === "fetching"}
          >
            {props.screenCreateStatus === "fetching" ? (
              <CircularProgressIndicator />
            ) : (
              <MdLink />
            )}
            Pair Now
          </Button>
        </div>
      </div>
    );

  const _screenName = screenTypes.find(
    (v) => v.id === props.screenInfo?.screenType,
  )?.title;

  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-4">
      <div className="flex h-full w-full flex-1 flex-col items-center justify-center gap-4">
        <div className="h-[350px] w-full py-4">
          <CustomCarousel
            items={pairInstructions[props.screenInfo?.screenType ?? "web"]}
          />
        </div>
        <Divider />
        <p className="text-center text-[0.8rem] text-gray-500 dark:text-gray-400">
          {`Seeing your design on ${_screenName} is so cool, Do you want to pair your ${_screenName} now?`}
        </p>
        <div className="flex gap-4">
          <Button
            variant="outline"
            className="w-48"
            disabled={props.screenCreateStatus === "fetching"}
            onClick={props.onPairLater}
          >
            {props.screenCreateStatus === "fetching" ? (
              <CircularProgressIndicator />
            ) : (
              <MdOutlineWatchLater />
            )}
            Pair Later
          </Button>

          <div className="h-12">
            <VerticalDivider message="OR" />
          </div>

          <Button
            className="w-48"
            variant="filled"
            onClick={() => {
              setisPairNowActive(true);
            }}
            disabled={props.screenCreateStatus === "fetching"}
          >
            {props.screenCreateStatus === "fetching" ? (
              <CircularProgressIndicator />
            ) : (
              <MdLink />
            )}
            Pair Now
          </Button>
        </div>
      </div>

      <Button
        variant="ghost"
        type="button"
        disabled={props.screenCreateStatus === "fetching"}
        onClick={() => {
          props.setSelectedPage(0);
        }}
      >
        <MdArrowBack />
        Previous
      </Button>
    </div>
  );
}

export default ScreenPairPage;
